import { useQuery } from '@apollo/client'

import {
  CommandModule,
  DEFAULT_SUBCONTRACTOR_ACTIONS,
  DynamicActionsProps,
} from './config'

import { GET_SUBCONTRACTORS_BY_BUILDER_FILTER_LIST } from '@/modules/subcontractors/graphQL'
import { routes } from '@/utils/index'

import {
  SubcontractorsByBuilderFilterListUiQuery,
  SubcontractorsByBuilderFilterListUiQueryVariables,
} from 'types/api.graphql'

export const DynamicSubcontractorActions: React.FC<DynamicActionsProps> = ({
  activePage,
  debouncedSearchText,
  replaceParentSubItems,
}) => {
  useQuery<
    SubcontractorsByBuilderFilterListUiQuery,
    SubcontractorsByBuilderFilterListUiQueryVariables
  >(GET_SUBCONTRACTORS_BY_BUILDER_FILTER_LIST, {
    variables: {
      searchString: debouncedSearchText,
      filter: {
        includeBuilderSubcontractor: false,
      },
      pagination: { limit: 10, offset: 0 },
    },
    skip:
      activePage !== CommandModule.Subcontractors ||
      !debouncedSearchText?.length,
    onCompleted: (data) => {
      replaceParentSubItems(CommandModule.Subcontractors, [
        ...DEFAULT_SUBCONTRACTOR_ACTIONS,
        ...(data?.subcontractorsByBuilder?.map((subbie) => ({
          id: subbie.id,
          name: subbie.company.name,
          href: routes.subcontractors.view(subbie.id),
        })) ?? []),
      ])
    },
  })

  return null
}
